import { productColorApi } from "../../api";

const ProductColorService = {
  /**
   * Obtener todos los colores registrados.
   */
  getAll: async () => {
    try {
      const response = await productColorApi.fetchAll();
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtener colores activos para un menú desplegable.
   */
  getDropdown: async () => {
    try {
      const response = await productColorApi.fetchCustom("/dropdown");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Buscar colores activos para dropdown (code/name).
   */
  searchDropdown: async (query: string) => {
    try {
      const response = await productColorApi.fetchCustom(
        `/dropdown/search?query=${encodeURIComponent(query)}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtener un color por ID.
   */
  getById: async (id: number) => {
    try {
      const response = await productColorApi.fetchById(id);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Buscar colores por código o nombre.
   */
  search: async (query: string) => {
    try {
      const response = await productColorApi.fetchCustom(`/search?query=${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Crear un nuevo color.
   */
  save: async (data: object) => {
    try {
      const response = await productColorApi.add(data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Actualizar un color existente.
   */
  update: async (id: number, data: object) => {
    try {
      const response = await productColorApi.modify(id, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Activar o desactivar un color.
   */
  toggleStatus: async (id: number) => {
    try {
      const response = await productColorApi.patchCustom(`${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ProductColorService;
